export enum LayoutSize {
  Container = 920,
  Content = 728,
}
